import { render, staticRenderFns } from "./HistoryIframe.vue?vue&type=template&id=096e22dd&scoped=true"
import script from "./HistoryIframe.vue?vue&type=script&lang=js"
export * from "./HistoryIframe.vue?vue&type=script&lang=js"
import style0 from "./HistoryIframe.vue?vue&type=style&index=0&id=096e22dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096e22dd",
  null
  
)

export default component.exports